import { render } from "./detail_head.vue?vue&type=template&id=7da6ef7a&scoped=true"
const script = {}

import "./detail_head.vue?vue&type=style&index=0&id=7da6ef7a&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7da6ef7a"]])

export default __exports__